 
import axiosInstance from './axiosInstance'; 

export const getFaq = async (payload) => {
  const response = await axiosInstance.post('/api/faqs/getAll', payload);
  return response.data;
};
